/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ReactNode } from "react";

import { numericViewportHeight, spacing } from "../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../lib/constants/emotionMediaQueries.constants";
import type { HallowElementProps } from "../../../types/hallowElementProps.types";

const topContainerStyle: Interpolation = {
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: spacing.ml,
  justifyContent: "flex-start",
  paddingBottom: spacing.none,
  paddingInline: spacing.none,
  paddingTop: spacing.none,
  [cssMediaQueryMinWidthTablet]: { paddingTop: numericViewportHeight[20] },
  width: spacing.full,
};
const footerStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.ml,
  justifyContent: "flex-end",
  padding: spacing.none,
  width: spacing.full,
};

type AuthLayoutProps = HallowElementProps<"div"> & {
  footer: ReactNode;
  footerCSS?: Interpolation;
};

export const AuthLayout = ({
  children,
  className,
  footer,
  footerCSS = {},
  ...props
}: AuthLayoutProps) => (
  <>
    <div
      className={className}
      key={"auth-top"}
      css={[topContainerStyle]}
      {...props}
    >
      {children}
    </div>
    <div key={"auth-bottom"} css={[footerStyle, footerCSS]}>
      {footer}
    </div>
  </>
);
